import { Link } from 'react-router-dom';
import { ButtonBase } from '@mui/material';
import { APP_DEFAULT_PATH } from 'config';
import FooterLogoIcon from './FooterLogoIcon';
import FooterLogoMain from './FooterLogoMain';
import { LogoSectionProps } from 'types/components';

const FooterLogoSection = ({ reverse, isIcon, sx, to, disabled }: LogoSectionProps) => (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} disabled={disabled} sx={sx}>
        {isIcon ? <FooterLogoIcon /> : <FooterLogoMain reverse={reverse} />}
    </ButtonBase>
);

export default FooterLogoSection;
